module.exports = __webpack_public_path__ + "img/contentImg2.2452403.png";